import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

import pl from './locales/pl.json';

export const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'pl',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'pl',
  messages: { pl }
});

const loadedLanguages = ['pl'];

function setI18nLanguage(lang: string) {
  i18n.locale = lang;
  return lang;
}

export function loadLanguageAsync(lang: string) {
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  return import(/* webpackChunkName: "lang-[request]" */ `./locales/${lang}.json`).then(messages => {
    i18n.setLocaleMessage(lang, messages.default);
    loadedLanguages.push(lang);
    return setI18nLanguage(lang);
  });
}
